import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DataTableSelectionComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'rdatatable-selection',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RDataTableSelectionComponent extends DataTableSelectionComponent {}
